export default __webpack_public_path__ + "static/media/producto-14.9705ff33.jpeg";